import { CreatorRestControllerService } from '@api'

import { CreatorProxyStatus } from '@/modules/creators/types.ts'
import { apiClient } from '@/utils/axios.ts'

async function deleteCreator(creatorId: number) {
  return CreatorRestControllerService.deleteCreator({ creatorId })
}

async function getCreatorStates() {
  // BE add types
  return CreatorRestControllerService.listCreatorsStates() as unknown as Promise<
    CreatorProxyStatus[]
  >
}

export const creatorService = {
  deleteCreator,
  getCreatorStates,
}
